import React, { useState } from 'react';
import { ComponentAlerts } from './ComponentAlerts';
import { CardContainer } from './CardContainer';

export const MainContentFirma = ({setFileName}) => {
    const [canSign, setCanSign] = useState(false);
    const [errorMessageKey, setErrorMessageKey] = useState('');

    return (
        <main className="component-main-content-firma">

            <div className="page-container">
                {errorMessageKey && (
                    <ComponentAlerts alertType="error" alertMessageKey={errorMessageKey} />
                )}
                <CardContainer canSign={canSign} setCanSign={setCanSign} setErrorMessageKey={setErrorMessageKey}  setFileName={setFileName}/>
            </div>
        </main>
    );
};
